/**
 * Feature flag + tuning constants for viewport-gated EditorJS activation
 * (see `useViewportEditorActivation`). Large documents (~650 text-leaf
 * clusters / list blocks) pay for one live EditorJS instance per cluster —
 * this gates instantiation to "near the viewport" so far-offscreen blocks
 * render a cheap static equivalent instead.
 *
 * Defaults ON, but paired with a deliberately generous `rootMargin` so most
 * of a screenful stays mounted above/below the visible viewport — the goal
 * is to skip EditorJS for blocks that are genuinely far away, not to
 * aggressively tear down anything near the fold. If this ever needs to be
 * disabled quickly (regression triage), flip this one constant back to
 * `false` — every consumer falls back to "always mounted" (today's
 * behavior) when it's off.
 */
export const ENABLE_VIEWPORT_EDITOR_ACTIVATION = true;

/**
 * `IntersectionObserver` rootMargin used to decide whether a cluster/list
 * block counts as "near the viewport". Expressed as `top right bottom
 * left` (CSS shorthand order) — extended vertically only, since the editor
 * scrolls vertically and horizontal over-scan buys nothing.
 */
export const VIEWPORT_EDITOR_ROOT_MARGIN = '1600px 0px 1600px 0px';
